import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { AppService } from '@sinequa/core/app-utils';
import { IntlService } from '@sinequa/core/intl';
import { FEATURES } from '../../config';
import { EsWebService } from '../esWebService';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  constructor(
    private titleService: Title,
    private intlService: IntlService,
    public esService: EsWebService,
    private appService: AppService) { }

  /**
   * On initialization set the page title
   */
  ngOnInit() {
    this.titleService.setTitle(this.intlService.formatMessage("msg#app.name"));
  }

  /**
   * Returns the list of features activated in the top right menus.
   * The configuration from the config.ts file can be overriden by configuration from
   * the app configuration on the server
   */
  public get features(): string[] {
    return this.appService.app?.data?.features as string[] || FEATURES;
  }

  // Change the placeholder name
  ngAfterViewInit() {
    const a = document.querySelectorAll('input');
    a.forEach(btn => {
      btn.placeholder = 'Search existing research or ask a question';
    });
  }
}
